import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import Text from '../../../../../../shared/components/Text';
import Wrapper from '../../../../../../shared/components/Wrapper';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import ExportPdf from './components/ExportPdf';
import FrameGrid from './Frame/index';

function ApurationDashboard() {
  const apurationData = useSelector(
    (reducer: IReducer) => reducer.apurationAppData
  );

  const numeroContas = [
    apurationData.totalAccountsActives,
    apurationData.totalAccountsPending,
    apurationData.totalAccountsRejected,
    apurationData.totalAccountsBlocked,
    apurationData.totalAccountsFinished,
  ];

  const valoresAReceber = [
    apurationData.consignedValueToReceive,
    apurationData.escrowValueToReceive,
    apurationData.pfMovementValueToReceive,
    apurationData.pjMovementValueToReceive,
  ];

  return (
    <>
      <FrameGrid.Base isActive={apurationData.isActive}>
        <Card
          isActive
          title="Contas Totais"
          subtitle="Apuração de contas do parceiro"
          display="flex"
          gridArea="totais"
          justifyContent="space-evenly"
          flexDirection="row"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <Text.Description>Total</Text.Description>
            <CardValue color={theme.colors.lightGray}>
              {checkValue(
                numeroContas.reduce((total, n) => {
                  const result = total + n;
                  return result;
                }, 0)
              )}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <Text.Description>Ativas</Text.Description>
            <CardValue color={theme.colors.active}>
              {checkValue(apurationData.totalAccountsActives)}
            </CardValue>
          </LabelAndValueContainer>

          <LabelAndValueContainer alignCenter>
            <Text.Description>Pendentes</Text.Description>
            <CardValue color={theme.colors.pending}>
              {checkValue(apurationData.totalAccountsPending)}
            </CardValue>
          </LabelAndValueContainer>

          <LabelAndValueContainer alignCenter>
            <Text.Description>Rejeitadas</Text.Description>
            <CardValue color={theme.colors.rejected}>
              {checkValue(apurationData.totalAccountsRejected)}
            </CardValue>
          </LabelAndValueContainer>

          <LabelAndValueContainer alignCenter>
            <Text.Description>Bloqueadas</Text.Description>
            <CardValue color={theme.colors.blocked}>
              {checkValue(apurationData.totalAccountsBlocked)}
            </CardValue>
          </LabelAndValueContainer>

          <LabelAndValueContainer alignCenter>
            <Text.Description>Encerradas</Text.Description>
            <CardValue color={theme.colors.desactivated}>
              {checkValue(apurationData.totalAccountsFinished)}
            </CardValue>
          </LabelAndValueContainer>
        </Card>
        <Card
          isActive
          title="Apuração de Contas Ativas"
          display="flex"
          gridArea="apuracao"
          justifyContent="center"
          flexDirection="column"
          backgroundColor="#FFFFFF">
          <Wrapper.Default
            isActive
            flexDirection="row"
            justifyContent="space-between"
            heigth="100%"
            width="100%">
            <Wrapper.Default isActive justifyContent="space-around">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Tipo de Conta</Text.Description>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>Consignada</CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>Escrow</CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>Movimento PF</CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>Movimento PJ</CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>

            <Wrapper.Default isActive justifyContent="space-around">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Qnt.</Text.Description>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.consignedQuantity)}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.escrowQuantity)}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.pfMovementQuantity)}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.pjMovementQuantity)}
                </CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>

            <Wrapper.Default isActive justifyContent="space-around">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Valor da Tarifa</Text.Description>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.consignedFare).toLocaleString(
                    'pt-br',
                    {
                      style: 'currency',
                      currency: 'BRL',
                    }
                  )}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.escrowFare).toLocaleString(
                    'pt-br',
                    {
                      style: 'currency',
                      currency: 'BRL',
                    }
                  )}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.pfMovementFare).toLocaleString(
                    'pt-br',
                    {
                      style: 'currency',
                      currency: 'BRL',
                    }
                  )}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(apurationData.pjMovementFare).toLocaleString(
                    'pt-br',
                    {
                      style: 'currency',
                      currency: 'BRL',
                    }
                  )}
                </CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>

            <Wrapper.Default isActive justifyContent="space-around">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Valor a receber</Text.Description>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(
                    apurationData.consignedValueToReceive
                  ).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(
                    apurationData.escrowValueToReceive
                  ).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(
                    apurationData.pfMovementValueToReceive
                  ).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </CardLabel>
              </LabelAndValueContainer>
              <LabelAndValueContainer alignCenter>
                <CardLabel>
                  {checkValue(
                    apurationData.pjMovementValueToReceive
                  ).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>
          </Wrapper.Default>
          <Wrapper.Default isActive alignItens="flex-end" width="100%">
            <CardValue color={theme.colors.active}>
              {checkValue(
                valoresAReceber.reduce((total, n) => {
                  const result = total + n;
                  return result;
                }, 0)
              ).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </CardValue>
          </Wrapper.Default>
        </Card>
        <Card
          isActive
          title="Encerradas Não Tarifadas"
          display="flex"
          gridArea="encerradas"
          justifyContent="space-evenly"
          flexDirection="column"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <Wrapper.Default
            isActive
            flexDirection="row"
            justifyContent="space-evenly"
            heigth="100%"
            width="100%">
            <Wrapper.Default
              isActive
              justifyContent="space-around"
              heigth="100%">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Total Encerradas</Text.Description>
                <CardLabel>
                  {checkValue(apurationData.totalAccountsFinished)}
                </CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>

            <Wrapper.Default
              isActive
              justifyContent="space-around"
              heigth="100%">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Tarifadas</Text.Description>

                <CardLabel color={theme.colors.active}>
                  {checkValue(apurationData.activeFares)}
                </CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>

            <Wrapper.Default
              isActive
              justifyContent="space-around"
              heigth="100%">
              <LabelAndValueContainer alignCenter>
                <Text.Description>Não Tarifada</Text.Description>

                <CardLabel color={theme.colors.blocked}>
                  {checkValue(apurationData.finishedFares)}
                </CardLabel>
              </LabelAndValueContainer>
            </Wrapper.Default>
          </Wrapper.Default>
        </Card>
      </FrameGrid.Base>
      <FrameGrid.PdfButton isActive>
        <ExportPdf />
      </FrameGrid.PdfButton>
    </>
  );
}

export default ApurationDashboard;
